export const TUITION_STATUS = Object.freeze({
  PAID: 2,
})

export const STATUSES = [
  { value: 1, label: 'Hoạt động' },
  { value: 0, label: 'Không hoạt động' },
]

export const TYPE_FORMULAS = [
  { value: 1, label: 'Tổng điểm các môn cụ thể với từng hệ số' },
  { value: 0, label: 'Tổng điểm của các môn trong tổ hợp xét tuyển' },
]
export const SCOPE_CERTIFICATES = [
  { value: 1, label: 'Tỉnh/Thành phố' },
  { value: 0, label: 'Quốc gia/Quốc tế' },
]
export const PROGRAMME_STATUSES = [
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đang áp dụng' },
]
export const GRADUATION_PROJECT_REGISTER_STATUSES = [
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đang áp dụng' },
]
export const DIPLOMA_STATUSES = [
  { value: -1, label: 'Từ chối' },
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đã duyệt' },
  { value: 2, label: 'Đã đóng' },
]
export const TRANSFER_STATUSES = [
  { value: -1, label: 'Từ chối' },
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đã duyệt' },
]
export const TRANSFER_SUBJECT_STATUSES = [
  { value: 0, label: '(H) Phải học' },
  { value: 1, label: '(M) Miễn học' },
]
export const PROGRAMME_SUBJECT_TYPE = [
  { value: 0, label: 'HP bắt buộc' },
  { value: 1, label: 'HP tự chọn' },
]
export const COUNT_4_GPA_SYMBOLS = [
  { value: 0, label: '&#10060;' },
  { value: 1, label: '&#9989;' },
]
export const STATUS_SYMBOLS = [
  { value: 0, label: '&#10008;' },
  { value: 1, label: '&#10004;' },
]

export const MENU_TYPES = [
  { value: 1, label: 'Quản trị' },
  { value: 2, label: 'Portal' },
  { value: 3, label: 'Tuyển sinh' },
]

export const IS_OPTIONAL_SYMBOLS = [
  { value: 0, label: '&#10004;' },
  { value: 1, label: '&#10008;' },
]

export const CREDIT_CLASS_STATUSES = [
  { value: -1, label: 'Hủy lớp' },
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đang đăng ký' },
  { value: 2, label: 'Đăng ký mở rộng' },
  { value: 3, label: 'Đang học' },
  { value: 4, label: 'Kết thúc' },
]
export const CREDIT_CLASS_TEACHER_STATUSES = [
  { value: 0, label: 'Ngưng dạy' },
  { value: 1, label: 'Đang dạy' },
]
export const CREDIT_CLASS_STUDENT_STATUSES = [
  { value: -4, label: 'Thôi học' },
  { value: -3, label: 'Bảo lưu' },
  { value: -2, label: 'Không hoàn thành' },
  { value: -1, label: 'Rút đăng ký' },
  { value: 0, label: 'Đã đăng ký' },
  { value: 1, label: 'Đang học' },
  { value: 2, label: 'Đã hoàn thành' },
  { value: 3, label: 'Được miễn học' },
]

export const GENDERS = [
  { value: 0, label: 'Không xác định' },
  { value: 1, label: 'Nam' },
  { value: 2, label: 'Nữ' },
]
// Cảm tình đảng
export const HAS_LEARN_PARTY = [
  { value: 0, label: 'Chưa học' },
  { value: 1, label: 'Đã học' },
]

export const COURSE_SEMESTER_STATUSES = [
  { value: 0, label: 'Chưa học' },
  { value: 1, label: 'Đang học' },
  { value: 2, label: 'Đã kết thúc' },
]
export const STUDENT_CLASS_STATUSES = [
  { value: -2, label: 'Đình chỉ' },
  { value: -1, label: 'Thôi học' },
  { value: 0, label: 'Bảo lưu' },
  { value: 1, label: 'Đang học' },
  { value: 2, label: 'Đã hoàn thành chương trình' },
  { value: 3, label: 'Đã tốt nghiệp' },
]

export const ELIGIBLE_STATUSES = [
  { value: 0, label: 'Không' },
  { value: 1, label: 'Có' },
]

export const SEMESTER_NAME = [
  { value: 1, label: 'Học kỳ I' },
  { value: 2, label: 'Học kỳ II' },
  { value: 3, label: 'Học kỳ hè' },
]
export const LIMIT_OPTION = [
  { value: 0, label: 'Tất cả các ngành' },
  { value: 1, label: 'Top 5 ngành nhiêu SV theo học' },
  { value: 2, label: 'Top 10 ngành nhiêu SV theo học' },
]

export const ROOM_TYPES = [
  { value: 1, label: 'Phòng học lý thuyết' },
  { value: 2, label: 'Phòng máy tính' },
  { value: 3, label: 'Phòng thí nghiệm' },
]

export const YEARS = [
  { value: 1, label: 'Năm thứ nhất' },
  { value: 2, label: 'Năm thứ hai' },
  { value: 3, label: 'Năm thứ ba' },
  { value: 4, label: 'Năm thứ tư' },
]

export const SCORE_LOCKS = [
  { value: 0, text: 'Mở khóa' },
  { value: 1, text: 'Khóa' },
]

export const ADMISSION_FORM_LOCKS = [
  { value: 1, label: 'Mở khóa' },
  { value: 0, label: 'Khóa' },
]

export const PAYMENT_STATUSES = [
  { value: 0, label: 'Chưa đóng' },
  { value: 1, label: 'Đã đóng' },
]

export const GRADUATION_TYPES = [
  { value: 1, label: 'Thi tốt nghiệp' },
  { value: 2, label: 'Làm khóa luận tốt nghiệp' },
]
export const GRADUATION_TYPE_STATUSES = [
  { value: 0, label: 'Chưa đạt điều kiện xét duyệt' },
  { value: 1, label: 'Thi tốt nghiệp' },
  { value: 2, label: 'Làm khóa luận tốt nghiệp' },
]

export const NOTIFICATION_STATUSES = [
  { value: 0, label: 'Dự thảo' },
  { value: 1, label: 'Đã gửi' },
]
export const ABSENT_TYPES = [
  // { value: -1, label: 'Hủy bỏ vắng mặt' },
  { value: 0, label: 'Không lý do' },
  { value: 1, label: 'Có lý do' },
]
export const EXAM_DEDUCT_TYPE = [
  { value: 1, label: 'Trừ vào tổng điểm' },
  { value: 2, label: 'Trừ phần trăm tổng điểm' },
]

export const CHECK_EXAMINATION_PAPERS = [
  { value: 1, label: 'Đang xử lý' },
  { value: 2, label: 'Đã xử lý' },
]

export const REPLACE_THESIS_SUBJECT_TYPES = [
  { value: 0, label: 'Không' },
  { value: 1, label: 'Có' },
]
export const SUSPEND_STATUSES = [
  { value: -1, label: 'Cảnh báo' },
  { value: 1, label: 'Thôi học' },
]

export const STANDARD_SCORE_STATUSES = [
  { value: 0, label: 'Chưa xác nhận' },
  { value: 1, label: 'Đã xác nhận' },
]

export const CONFIRM_ADMISSION_STATUSES = [
  { value: 0, label: 'Chưa xác nhận' },
  { value: 1, label: 'Đã xác nhận' },
]

export const ADMISSION_CONFIRM_CERTIFICATE_STATUSES = [
  { value: -1, label: 'Không chấp nhận' },
  { value: 0, label: 'Chờ xác nhận' },
  { value: 1, label: 'Chấp nhận' },
]

export const ADMISSION_CONFIRM_CERTIFICATE_TYPES = [
  { value: 0, label: 'Giấy xác nhận đối tượng ưu tiên' },
  { value: 1, label: 'Thành tích học tập' },
  { value: 2, label: 'Chứng chỉ ngoại ngữ' },
]

export const CATEGORY_LOGS = [
  { value: 'LOGIN', label: 'Đăng nhập hệ thống' },
  { value: 'UPDATE_RECEIPT', label: 'Cập nhật phiếu thu' },
  { value: 'CREATE_ACCOUNT_ROLES', label: 'Tạo tài khoản' },
  { value: 'CHANGE_ACCOUNT_ROLES', label: 'Thay đổi quyền tài khoản' },
  { value: 'RESET_PASSWORD', label: 'Đặt lại mật khẩu' },
  { value: 'CHANGE_PASSWORD', label: 'Thay đổi mật khẩu' },
  { value: 'DELETE_CREDIT_CLASS', label: 'Xóa lớp độc lập' },
  { value: 'EXAMINATION_SCORE_LOCKED', label: 'Khóa/mở nhập điểm thi theo học phần' },
  { value: 'CHANGE_STATUS_CREDIT_CLASS_STUDENT', label: 'Thay đổi trạng thái sinh viên trong lớp độc lập' },
  { value: 'DIPLOMA_REVIEWS', label: 'Đăng ký song ngành' },
  { value: 'UPDATE_SCORE_LOCKED', label: 'Khóa/mở nhập điểm theo lớp' },
  { value: 'REGISTER_SUBJECT', label: 'Đăng ký học phần' },
  { value: 'SUSPENDED_STUDENT', label: 'Buộc thôi học' },
  { value: 'CHANGE_INFO_STUDENT_CLASS', label: 'Thay đổi thông tin sinh viên' },
  { value: 'ENTER_POINT_EXAMINATION_ROOM', label: 'Nhập điểm thi' },
  { value: 'STUDY_SUMMARIES', label: 'Tổng kết học kỳ' },
  { value: 'ENTER_PRACTICE_SCORE', label: 'Điểm thực hành' },
  { value: 'ENTER_FIRST_POINT', label: 'Điểm hệ số 2' },
  { value: 'ENTER_SECOND_POINT', label: 'Điểm hệ số 3' },
  { value: 'CHECK_EXAMINATION', label: 'Phúc khảo' },
  { value: 'CONDUCT_POINT', label: 'Điểm rèn luyện' },
  { value: 'CANCEL_REGISTER_SUBJECT', label: 'Hủy đăng ký học phần tín chỉ' },
]

export const EXAMINATION_STATUS = [
  { value: 0, label: 'Mới mở' },
  { value: 1, label: 'Hoạt động' },
  { value: 2, label: 'Kết thúc' },
]

export const BACKUP_STATUS = [
  { value: 0, label: 'Thất bại' },
  { value: 1, label: 'Hoàn tất' },
]

export const RESEARCH_EVALUATIONS = [
  { value: 0, label: 'Không đạt' },
  { value: 1, label: 'Đạt' },
  { value: 2, label: 'Xuất sắc' },
]

export const GRANT_STATUS = [
  { value: 0, label: 'Chưa gán' },
  { value: 1, label: 'Đã gán' },
]

export const RESEARCH_INVENTION_STATUSES = [
  { value: 0, text: 'Chưa được chấp nhận' },
  { value: 1, text: 'Được chấp nhận' },
]

export const RESEARCH_STATUSES = [
  { value: 0, text: 'Đang nghiên cứu' },
  { value: 1, text: 'Đang xét duyệt' },
  { value: 2, text: 'Đã kết thúc' },
]

export const TITLE_TYPES = [
  { value: 1, label: 'Sinh viên' },
  { value: 0, label: 'Giảng viên' },
]

export const RANK_CERTIFICATE_TYPES = [
  { value: 1, label: 'NHẤT' },
  { value: 2, label: 'NHÌ' },
  { value: 3, label: 'BA' },
  { value: 4, label: 'KHUYẾN KHÍCH/TƯ' },
]

export const ADMISSION_REVENUE_PLAN_TYPES = [
  { value: 0, label: 'Không' },
  { value: 1, label: 'Thu theo số lượng nguyện vọng' },
]

export const CRITERIA_REQUIRES = [
  { value: 1, label: 'Có' },
  { value: 0, label: 'Không' },
]
export const STORAGE_MAINTENANCE_BACKUP = 1024
export const DATA_GROWTH_CHART = [
  { value: 1, label: 'Dữ liệu theo ngày' },
  { value: 7, label: 'Dữ liệu theo tuần' },
  { value: 30, label: 'Dữ liệu theo tháng' },
]

// Văn bằng/chứng chỉ
export const CREDENTIAL_TYPE = [
  { value: 1, label: 'Văn bằng' },
  { value: 0, label: 'Chứng chỉ' },
]
export const STATUSES_CREDENTIAL = [
  { value: 0, label: 'Không hoạt động' },
  { value: 1, label: 'Hoạt động' },
  { value: 2, label: 'Đang triển khai' },
]
export const STATUSES_PROCESS_HISTORY = [
  { value: 2, label: 'Đã xử lý' },
  { value: 1, label: 'Đang xử lý' },
  { value: 0, label: 'Chờ xét duyệt' },
  { value: -1, label: 'Bị từ chối' },
]
export const PROCESS_CODES = [
  { value: 'ADD_CREDENTIAL', label: 'Mã yêu cầu bổ sung' },
  { value: 'UPDATE_CREDENTIAL', label: 'Mã yêu cầu chỉnh sửa' },
  { value: 'COPY_CREDENTIAL', label: 'Mã yêu cầu cấp bản sao' },
]
export const RECEIPT_STATUSES = [
  { value: 1, label: 'Chưa nộp học phí' },
  { value: 2, label: 'Đã nộp học phí' },
  { value: 3, label: 'Yêu cầu hoàn tiền' },
]
export const DAY_SESSIONS = [
  { value: 1, text: 'Sáng' },
  { value: 2, text: 'Chiều' },
  { value: 3, text: 'Tối' },
]

export const EXAM_SHIFT_SCHEDULE = [
  { value: 1, text: 'Ca 1' },
  { value: 2, text: 'Ca 2' },
  { value: 3, text: 'Ca 3' },
  { value: 4, text: 'Ca 4' },
  { value: 5, text: 'Ca 5' },
  { value: 6, text: 'Ca 6' },
]

// TODO chờ lấy tên loại thủ tục
export const OG_PROCEDURE_TYPE = [
  { value: 1, label: 'Thủ tục 1' },
  { value: 2, label: 'Thủ tục 2' },
  { value: 3, label: 'Thủ tục 3' },
]
export const TEMPLATE_FILE_TYPE = [
  { value: 1, label: 'Mẫu hồ sơ đính kèm thủ tục', accessTemplate: true },
  { value: 2, label: 'Mẫu kết quả xử lý quy trình', accessTemplate: true },
]
export const DOSSIER_STATUS = [
  { value: 0, label: 'Chờ tiếp nhận' },
  { value: 1, label: 'Đang xử lý' },
  { value: 2, label: 'Hoàn thành' },
  { value: 3, label: 'Từ chối' },
  { value: 4, label: 'Yêu cầu bổ sung hồ sơ' },
  { value: 5, label: 'Lưu nháp' },
  { value: 6, label: 'Hủy bỏ' },
  { value: 7, label: 'Đã bổ sung hồ sơ' },
]

export const FILE_UPLOAD_DOSSIER_STATUS = [
  { value: 1, label: 'File mới, chuẩn bị đẩy lên Minio' },
  { value: 2, label: 'File đã upload lên Minio' },
]

export const RESEARCH_RESULT_STATUSES = [
  { value: 0, text: 'Không đạt' },
  { value: 1, text: 'Đạt' },
]

export const QB_EXAM_STATUSES = [
  { value: -1, label: 'Bản nháp tạo từ trộn đề' },
  { value: 1, label: 'Bản nháp' },
  { value: 2, label: 'Đã được duyệt' },
  { value: 3, label: 'Đã lưu trữ' },
]

export const MIX_EXAMS = [
  { value: 3, label: '&#10008;' },
  { value: 2, label: '&#10008;' },
  { value: 1, label: '&#10008;' },
  { value: 0, label: '&#10008;' },
  { value: -1, label: '&#10004;' },
]

export const CERTIFICATE_TYPES = [
  { value: 3, label: 'Chứng chỉ thể chất' },
  { value: 2, label: 'Chứng chỉ ngoại ngữ' },
  { value: 1, label: 'Chứng chỉ quốc phòng' },
  { value: 0, label: 'Chứng chỉ tin học' },
]

export const CERTIFICATE_STATUS = [
  { value: -1, label: 'Không hợp lệ' },
  { value: 1, label: 'Hợp lệ' },
  { value: 0, label: 'Đang chờ xét duyệt' },
]
